import { IoCall, IoMail } from "react-icons/io5";
import React, { Suspense } from "react";
import dynamic from "next/dynamic";

const LinkItem = dynamic(() => import("./LinkItem"), {
  suspense: true,
});

const MobileFooter = () => {
  return (
    <footer className="bg-primary flex flex-col gap-4 py-4">
      <div className="px-2 text-white leading-6">
        <div>
          <h2 className="text-xl text-white">Contact Us</h2>
          <hr />
        </div>
        <div className="text-base leading-7">
          <p>Tariq Janjua</p>
          <p>Broker</p>
          <p>SUTTON Group - SUMMIT Realty Inc, Brokerage</p>
          <p>33 Pearl Street, Mississauga, On L5M1X1</p>
          <p style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <span>
              <IoCall style={{ marginTop: "2px" }} />
            </span>
            416-828-7773
          </p>
          <p style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <span>
              <IoMail style={{ marginTop: "3px" }} />
            </span>
            info@bungalowfinder.ca
          </p>
        </div>
      </div>
      <div className="px-2 text-white leading-7">
        <div>
          <h2 className="text-xl text-white">Popular Seaches</h2>
          <hr />
        </div>

        <div className="text-lg">
          <Suspense fallback={<></>}>
            <LinkItem
              search="/city/Mississauga?city=Mississauga&styles=&styles=Backsplit+3&page=1"
              title="Backsplit 3 for Sale"
            />
                        <span className="px-1">|</span>

            <LinkItem
              search="/city/Mississauga?city=Mississauga&styles=&styles=Backsplit+4&page=1"
              title="Backsplit 4 for Sale"
            />
                        <span className="px-1">|</span>

            <LinkItem
              search="/city/Mississauga?city=Mississauga&styles=&styles=Backsplit+5&page=1"
              title="Backsplit 5 for Sale"
            />
                        <span className="px-1">|</span>

            <LinkItem
              search="/city/Mississauga?city=Mississauga&styles=&styles=Bungaloft&page=1"
              title="Bungaloft for Sale"
            />
                        <span className="px-1">|</span>

            <LinkItem
              search="/city/Mississauga?city=Mississauga&styles=&styles=Backsplit+5&page=1"
              title="Backsplit 5 for Sale"
            />
                        <span className="px-1">|</span>

            <LinkItem
              search="/city/Mississauga?city=Mississauga&styles=&styles=Bungalow-Raised&page=1"
              title="Bungalow-Raised for sale "
            />
                        <span className="px-1">|</span>

            <LinkItem
              search="/city/Mississauga?city=Mississauga&styles=&styles=Sidesplit+3&page=1"
              title="Sidesplit 3 for Sale"
            />
                        <span className="px-1">|</span>

            <LinkItem
              search="/city/Mississauga?city=Mississauga&styles=&styles=Sidesplit+4&page=1"
              title="Sidesplit 4 for Sale"
            />
                        <span className="px-1">|</span>

            <LinkItem
              search="/city/Mississauga?city=Mississauga&styles=&styles=Sidesplit+5&page=1"
              title="Sidesplit 5 for Sale"
            />
          </Suspense>
        </div>
      </div>
      <div className="px-2 text-white leading-7">
        <div>
          <h2 className="text-xl text-white">Popular Cities</h2>
          <hr />
        </div>
        <div className="text-base leading-7">
          <Suspense fallback={<></>}>
            <LinkItem
              search="/city/Mississauga"
              title="Bungalows for sale Mississauga"
            />
            <span className="px-1">|</span>

            <LinkItem
              search="/city/Toronto"
              title="Bungalows for sale Toronto"
            />
            <span className="px-1">|</span>

            <LinkItem
              search="/city/Brampton"
              title="Bungalows for sale Brampton"
            />
            <span className="px-1">|</span>

            <LinkItem search="/city/Ajax" title="Bungalows for sale Ajax" />
            <span className="px-1">|</span>

            <LinkItem
              search="/city/Burlington"
              title="Bungalows for sale Burlington"
            />
            <span className="px-1">|</span>

            <LinkItem search="/city/Milton" title="Bungalows for sale Milton" />
            <span className="px-1">|</span>

            <LinkItem
              search="/city/Hamilton"
              title="Bungalows for sale Hamilton"
            />
            <span className="px-1">|</span>

            <LinkItem
              search="/city/Oakville"
              title="Bungalows for sale Oakville"
            />
            <span className="px-1">|</span>

            <LinkItem
              search="/city/Caledon"
              title="Bungalows for sale Caledon"
            />
          </Suspense>
        </div>
      </div>
      <div className="px-2 text-white leading-7">
        <div>
          <h2 className="text-xl text-white">Useful Links</h2>
          <hr />
        </div>
        <div className="text-lg leading-7">
          <LinkItem search={`/blogs`} title={`Blogs`} />{" "}
          <span className="px-1">|</span>
          <LinkItem search={`/calculators`} title={`Mortgage Calculators`} />
          <span className="px-1">|</span>
          <LinkItem
            search="/land-transfer-tax-calculator"
            title="Land Transfer Tax Calculator"
          />
          <span className="px-1">|</span>
          <LinkItem
            search="/land-transfer-tax-calculator"
            title="Land Transfer Tax Calculator"
          />
          <span className="px-1">|</span>
          <LinkItem search={`/contact-us`} title={`Contact Us`} />
          <span className="px-1">|</span>
          <LinkItem search={`/sitemap`} title={`Sitemap`} />
          <span className="px-1">|</span>
          <LinkItem search={`/terms`} title={`Privacy Policy`} />
        </div>
      </div>
    </footer>
  );
};
export default MobileFooter;
